import ga4 from './tools/ga4/init';
import plausible from './tools/plausible/init';
import snowplow from './tools/snowplow/init';

const initMethods = [ga4.init, plausible.init, snowplow.init];

function init() {
  initMethods.forEach((initMethod) => {
    initMethod();
  });
}

export default {
  init,
};
